<template>
  <div class="overall-bg pb-0">
    <b-container>
      <b-row>
        <b-col>
          <BackToMasters :flag="5" :goback="$router.back"></BackToMasters>
          <Headerlayout :headertext="$t('consigneePO.title')" />
        </b-col>
      </b-row>
    </b-container>
  </div>
  <div class="overall-bg pt-0">
    <b-container>
      <div class="form-white-bg">
        <b-row>
          <b-col class="position-relative prtable">
            <div>
              <b-row class="actioncardbg">
                <b-col lg="3" md="3" sm="3">
                  <div class="field">
                    <Datepickers :label="$t('ItemCategory.RateContract.fromdate')" :maxDate="TodayDate"
                      dateFormat="dd-mm-yy" v-model="CommonObj.fromdate" name="FromDate" id="FromDate"
                      :required-icon="true" @date-select="DateFilter()" />
                  </div>
                </b-col>
                <b-col lg="3" md="3" sm="3">
                  <div class="field">
                    <Datepickers :label="$t('ItemCategory.RateContract.todate')" :maxDate="TodayDate"
                      dateFormat="dd-mm-yy" v-model="CommonObj.todate" name="ToDate" id="ToDate"
                      :minDate="CommonObj.fromdate" :disabled="CommonObj.fromdate ? false : CommonObj.todatedisable
                        " :required-icon="false" @date-select="DateFilter()" />
                  </div>
                </b-col>
                <b-col lg="3" md="4" sm="6" cols="12" class="field">
                  <CustomDropdown label="Supplier" :items="ObjFilters.SupplierOption" v-model="ObjFilters.SupplierId"
                    name="Supplier" @change="SupplierOnChange" :rules="{ required: false }" :required-icon="false"
                    :disabled="false" :show-clear="false" />
                </b-col>
                <b-col lg="3" md="4" sm="6" cols="12" class="field">
                  <CustomDropdown label="Brand" :items="ObjFilters.BrandOption" v-model="ObjFilters.BrandId"
                    name="Brand" @change="BrandOnChange" :rules="{ required: false }" :required-icon="false"
                    :disabled="false" :show-clear="false" />
                </b-col>
                <b-col lg="3" md="4" sm="6" cols="12" class="field">
                  <CustomDropdown label="Model" :items="ObjFilters.ModelNumberOption" v-model="ObjFilters.ModelNumberId"
                    name="Model" @change="ModelNumberOnChange" :rules="{ required: false }" :required-icon="false"
                    :disabled="false" :show-clear="false" />
                </b-col>
                <b-col lg="3" md="4" sm="6" cols="12" class="field">
                  <CustomDropdown label="Size" :items="ObjFilters.SizeOption" v-model="ObjFilters.SizeId" name="Size"
                    @change="SizeOnChange" :rules="{ required: false }" :required-icon="false" :disabled="false"
                    :show-clear="false" />
                </b-col>
                <b-col lg="4" md="4" sm="4">
                  <div class="d-flex align-items-center justify-content-around">
                    <p class="selectedcount">
                      {{ CommonObj.SelectedItemsCount }} Selected
                    </p>
                    <div>
                      <span class="p-input-icon-left card-search">
                        <i class="pi pi-search pb-0" />
                        <TextField v-model="CommonObj.inputValue" type="text" placeholder="Search Item" clearable
                          name="Search Item" :rules="{ required: false }" id="Search Item" :required-icon="false"
                          @keyup="ItemSearchFunction()" label="" />
                      </span>
                    </div>
                    <!-- <div class="label-d-none field my-auto">
                      <span class="p-input-icon-left">
                        <i class="pi pi-search ms-2 pt-0" />
                        <TextField v-model="CommonObj.inputValue" type="text" placeholder="Search Item" clearable
                          name="Search Item" :rules="{ required: false }" id="Search Item" :required-icon="false"
                          @keyup="ItemSearchFunction()" label="" />
                      </span>
                    </div> -->
                  </div>
                </b-col>
                <b-col>
                  <Footer :savehide="false" CancelLabel="Clear" @clickclear="ClearDateFilter" />
                </b-col>
              </b-row>
              <SkeletonTableLoader :columns="POheaders" :loading="loading" />
              <!-- {{ Items }} -->
              <POETableview v-if="!loading" :rowHover="true" filterDisplay="menu" :loading="loading"
                responsiveLayout="scroll" :columns="POheaders" :globalFilterFields="globalFilterFields" :data="Items"
                @selection="SelectItem" :selectionMode="CommonObj.SelecttionMode" @row-click="" :seriaNlumber="true">
                <template v-slot:Add>
                  <span>
                    <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                  </span>
                </template>
                <template v-slot:field>
                  <span>
                    <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                  </span>
                </template>
                <template v-slot:Itemname1="{ data }">
                  <span>
                    {{ data.Itemname1 }}
                  </span>
                  <span class="spantxt">
                    {{ data.BarCode }}
                  </span>
                </template>
                <template v-slot:Brandmodelsize="{ data }">
                  <span class="spantxt">
                    <template v-if="data.BrandName">{{
                      data.BrandName
                    }}</template>
                    <template v-if="data.BrandName && data.ModelNumberName">/</template>
                    <template v-if="data.ModelNumberName">{{
                      data.ModelNumberName
                    }}</template>
                    <template v-if="
                      (data.BrandName || data.ModelNumberName) &&
                      data.SizeName
                    ">/</template>
                    <template v-if="data.SizeName">{{
                      data.SizeName
                    }}</template>
                  </span>
                </template>

                <template v-slot:StockInHandslot="{ data }">
                  <span>
                    {{
                      (
                        data.StockInHand -
                        (data.PickedQty + data.InTransist)
                      ).toFixed(2)
                    }}
                  </span>
                </template>
              </POETableview>
              <b-row>
                <b-col lg="10" class="d-flex flex-row-reverse">
                  <div class="savedraftbtn me-2">
                    <p @click="IsSubmit(1)">Save as draft</p>
                  </div>
                </b-col>
                <b-col lg="2">
                  <Footer @save="IsSubmit(0)" />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>

  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, reactive } from "vue";
import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";
import moment from "moment";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import { useRoute, useRouter } from "vue-router";

import BackToMasters from "../../../../../components/FormComponents/BacktoMaster.vue";
import CustomDropdown from "../../../../../components/FormComponents/Dropdown.vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import Badge from "primevue/badge";
import AddItemsVue from "../../../../../modules/Inventory/components/Transaction/AddItems.vue";
import POETableview from "../../../../../components/FormComponents/EditableTable.vue";
import Item from "../../../../../modules/Inventory/components/Transaction/Item.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import cancel from "../../../../../components/GeneralButtons/CancelButtton.vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import AddItemConfirmation from "../../../../../components/FormComponents/AddItemsConfirmation.vue";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import Datepickers from "../../../../../components/FormComponents/DatePicker.vue";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";
import WithoutStockService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";
import { useConsigneeStore } from "../../../../../modules/Inventory/stores/ConsigneePOStore";
import SupplierMasService from "../../../../../modules/Inventory/Service/SupplierMaster";
import ItemConfigurationService from "../../../../../modules/Inventory/Service/ItemConfiguration";

export default defineComponent({
  components: {
    Datepickers,
    Badge,
    AddItemsVue,
    Item,
    POETableview,
    Footer,
    cancel,
    BackToMasters,
    Headerlayout,
    TextField,
    AddItemConfirmation,
    CustomDropdown,
    SkeletonTableLoader,
  },
  props: {
    showone: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    debugger;
    const toast = useToast();
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    let useConsigneePOStore = useConsigneeStore();

    let QueryStringValue = ref(route.query);

    // Get the Roles and Users Data from the Local Storage
    let SessionRolesData: any = localStorage.getItem("RolesData");
    let rolesData;
    SessionRolesData = JSON.parse(SessionRolesData);
    if (SessionRolesData !== null) {
      rolesData = SessionRolesData;
    }

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    // End

    let loading = ref(false);
    const Items: any = ref([]);
    const HiddenItems: any = ref([]);
    const TodayDate = new Date();

    const AddItemmodel = ref(false);
    const selectedItems: any = ref([]);

    let CommonObj = ref({
      inputValue: "",
      fromdate: ref(),
      todate: ref(),
      todatedisable: true,
      SelectedItemsCount: 0,
      SelecttionMode: true,
      SaveAsDraft: 0,
    });

    let ObjFilters = ref({
      SupplierOption: [],
      SupplierId: ref(),
      BrandOption: [],
      BrandId: ref(),
      ModelNumberOption: [],
      ModelNumberId: ref(),
      SizeOption: [],
      SizeId: ref()
    })

    // For Get Current date and time in sql server format
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const milliseconds = now.getMilliseconds();

    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${milliseconds
          .toString()
          .padStart(3, "0")}`;
    // end

    const ObjVal = ref({
      Id: 0,
      DocType: "5",
      DocNo: "",
      DocDate: formattedDate,
      RefId: 0,
      RefNo: "",
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      SupplierId: 0,
      Amount: 0.0,
      TaxAmount: 0.0,
      SGSTTaxAmount: 0.0,
      CGSTTaxAmount: 0.0,
      IGSTTaxAmount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      PaymentTermsId: 0,
      DeliveryTermsId: 0,
      IsDraft: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsServiceLevel: 0,
    });

    const POheaders = [
      {
        header: t("storetabdetails.pocreationtable.SupplierName"),
        field: "SupplierName",
        bodyclass: "boldclass",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.Category"),
        field: "ItemCategory1",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.Code"),
        field: "ItemProductId",
        class: "smallwidth coumnfreezeleft1",
      },
      {
        header: t("storetabdetails.pocreationtable.Name"),
        field: "Itemname1",
        slot: "Itemname1",
        fieldDisplay: "false",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth coumnfreezeleft2",
      },
      {
        header: t("storetabdetails.pocreationtable.Brand/Model/Size"),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.pocreationtable.BatchNo"),
        field: "BatchNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.ExpiryDate"),
        field: "ExpiryDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.UOM"),
        field: "UOMName",
        bodyclass: "text_overflow2",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.UnitRate"),
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.Qty"),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.Rate"),
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.AvlQty"),
        slot: "StockInHandslot",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.PickedQty"),
        field: "PickedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.pocreationtable.InTransist"),
        field: "InTransist",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
    ];

    const globalFilterFields = ref(POheaders.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    onMounted(async () => {
      debugger;

    });

    async function DateFilter() {
      debugger;
      if (CommonObj.value.fromdate != null) {
        await LoadConsigneeItems();
        await LoadSupplier();
        await LoadItemConfigurations();
      }
    }

    function ClearDateFilter() {
      debugger;
      CommonObj.value.fromdate = "";
      CommonObj.value.todate = "";
      ObjFilters.value.SupplierId = null;
      ObjFilters.value.BrandId = null;
      ObjFilters.value.ModelNumberId = null;
      ObjFilters.value.SizeId = null;

      LoadConsigneeItems();
    }

    async function LoadSupplier() {
      debugger;
      try {
        const dataresponse = await SupplierMasService.GetSuppliersByStoreId(
          QueryStringValue.value.StoreId,
          QueryStringValue.value.BranchId,
        );

        ObjFilters.value.SupplierOption = dataresponse["result"]
          .filter((i1) => i1.IsActive == true &&
            HiddenItems.value.some((hiddenItem) => hiddenItem.SupplierId === i1.Id))
          .map((item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    async function SupplierOnChange() {
      debugger;
      if (ObjFilters.value.SupplierId) {
        await LoadConsigneeItems()
      }
    }

    async function LoadItemConfigurations() {
      debugger;

      try {
        const response = await ItemConfigurationService.List();
        ObjFilters.value.BrandOption = response["result"]
          .filter(
            (f) =>
              HiddenItems.value.some((hiddenItem) => hiddenItem.Brand === f.Id) &&
              f.IsActive === true &&
              f.HospitalId === usersData.OrganizationId &&
              f.ICTypeId === 1
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });

        ObjFilters.value.ModelNumberOption = response["result"]
          .filter(
            (f) =>
              HiddenItems.value.some((hiddenItem) => hiddenItem.ModelNumber === f.Id) &&
              f.IsActive == true &&
              f.HospitalId == usersData.OrganizationId &&
              f.ICTypeId == 2
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });

        ObjFilters.value.SizeOption = response["result"]
          .filter(
            (f) =>
              HiddenItems.value.some((hiddenItem) => hiddenItem.Size === f.Id) &&
              f.IsActive == true &&
              f.HospitalId == usersData.OrganizationId &&
              f.ICTypeId == 3
          )
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });


      } catch (error) {
        alert(error);
      }
    }

    async function BrandOnChange() {
      debugger;
      if (ObjFilters.value.BrandId) {
        await LoadConsigneeItems()
      }
    }

    async function ModelNumberOnChange() {
      debugger;
      if (ObjFilters.value.ModelNumberId) {
        await LoadConsigneeItems()
      }
    }

    async function SizeOnChange() {
      debugger;
      if (ObjFilters.value.SizeId) {
        await LoadConsigneeItems()
      }
    }

    async function LoadConsigneeItems() {
      debugger;
      try {
        loading.value = true;

        const fromDate = CommonObj.value.fromdate
          ? moment(CommonObj.value.fromdate).format("YYYY-MM-DD")
          : "";
        const toDate =
          CommonObj.value.todate && CommonObj.value.todate != null
            ? moment(CommonObj.value.todate).format("YYYY-MM-DD")
            : moment().format("YYYY-MM-DD");

        const response =
          await WithoutStockService.GetConsigneeItemsFromStockOut(
            QueryStringValue.value.StoreId,
            QueryStringValue.value.BranchId,
            usersData.OrganizationId,
            fromDate,
            toDate,
            ObjFilters.value.SupplierId || 0,
            ObjFilters.value.BrandId || 0,
            ObjFilters.value.ModelNumberId || 0,
            ObjFilters.value.SizeId || 0
          );

        Items.value = response["result"].map((item) => {

          item.ExpiryDate =
            item.ExpiryDate && item.ExpiryDate == "01-01-1900"
              ? ""
              : item.ExpiryDate;

          item.UnitRate = Number(item.UnitRate).toFixed(2);

          item.StockOutId = item.StockOutId;

          item.StockOutDetailId = item.StockOutDetailId;

          item.Rate = Number(item.ItemQuantity * item.UnitRate).toFixed(2);

          item.Purchasetaxamount = Number(
            (item.PurchasePercentage * item.Rate) / 100
          ).toFixed(2);

          if (usersData.BranchStateId != item.SupplierStateId) {
            item.SGSTTax = 0;
            item.SGSTTaxAmount = 0.0;

            item.CGSTTax = 0;
            item.CGSTTaxAmount = 0.0;

            item.IGSTTax = Number(item.PurchasePercentage);
            item.IGSTTaxAmount = Number(
              (item.PurchasePercentage * item.Rate) / 100
            ).toFixed(2);
          } else {
            item.SGSTTax = Number(item.PurchasePercentage) / 2;
            item.SGSTTaxAmount = Number(
              Number(item.Purchasetaxamount) / 2
            ).toFixed(2);

            item.CGSTTax = Number(item.PurchasePercentage) / 2;
            item.CGSTTaxAmount = Number(
              Number(item.Purchasetaxamount) / 2
            ).toFixed(2);

            item.IGSTTax = 0;
            item.IGSTTaxAmount = 0.0;
          }

          item.Amount = Number(
            Number(item.Rate) +
            Number(item.SGSTTaxAmount) +
            Number(item.CGSTTaxAmount) +
            Number(item.IGSTTaxAmount)
          ).toFixed(2);

          return item;
        });

        HiddenItems.value = Items.value;

        for (let i = 0; i < Items.value.length; i++) {
          ObjVal.value.Amount += parseFloat(Items.value[i]["Amount"]);
          // ObjVal.value.TaxAmount += parseFloat(Items.value[i]["Purchasetaxamount"]);
          // ObjVal.value.SGSTTaxAmount += parseFloat(Items.value[i]["SGSTTaxAmount"]);
          // ObjVal.value.CGSTTaxAmount += parseFloat(Items.value[i]["CGSTTaxAmount"]);
          // ObjVal.value.IGSTTaxAmount += parseFloat(Items.value[i]["IGSTTaxAmount"]);
        }

        loading.value = false;
      } catch (error) {
        alert(error);
        loading.value = false;
      }
    }

    function ItemSearchFunction() {
      debugger;

      let SearchText = CommonObj.value.inputValue;
      let regex = new RegExp(SearchText, "i");

      try {
        Items.value = HiddenItems.value.filter(
          (f) =>
            regex.test(f.Itemname1) ||
            regex.test(f.ItemProductId) ||
            regex.test(f.ItemCategory1) ||
            regex.test(f.SupplierName) ||
            regex.test(f.BrandName) ||
            regex.test(f.ModelNumberName) ||
            regex.test(f.SizeName) ||
            regex.test(f.UOMName) ||
            regex.test(f.UnitRate) ||
            regex.test(f.ItemQuantity) ||
            regex.test(f.Rate)
        );
        console.log(Items);
      } catch (error) {
        alert(error);
      }
    }

    const selectedIndices: any = ref([]);

    function SelectItem(value) {
      debugger;

      selectedItems.value = value;

      CommonObj.value.SelectedItemsCount = selectedItems.value.length;

      // Get the indices of selected rows
      selectedIndices.value = [];
      for (let i = 0; i < value.length; i++) {
        selectedIndices.value.push(Items.value.indexOf(value[i]));
      }

      // Now selectedIndices array contains the indices of selected rows
      console.log(selectedIndices);
    }

    function IsSubmit(value) {
      debugger;
      CommonObj.value.SaveAsDraft = value;
      IsCreatePO();
    }

    // Create PO
    async function IsCreatePO() {
      debugger;
      let result: any = "";
      let message;
      let id = 0;
      let arraylength = Items.value.length;
      let QuantityValues: any = [];

      for (let i = 0; i < selectedItems.value.length; i++) {
        QuantityValues.push(selectedItems.value[i]["ItemQuantity"]);
      }
      // Filtering out non-numeric values and converting them to numbers
      let numericValues: number[] = QuantityValues.filter(
        (value) => typeof value === "number" || !isNaN(Number(value))
      ).map((value) => Number(value));

      // Calculating the sum of the numeric values
      let SumValues: number = numericValues.reduce(
        (acc, value) => acc + value,
        0
      );
      console.log(SumValues);
      if (SumValues > 0) {
        let suppliers: any = [];
        for (let i = 0; i < selectedItems.value.length; i++) {
          let supplier = selectedItems.value[i].SupplierId;
          if (selectedItems.value[i]["SupplierId"] != 0) {
            suppliers.push(selectedItems.value[i]["SupplierId"]);
          }
        }
        let uniqueSuppliers = suppliers.filter((supplier, index) => {
          return suppliers.indexOf(supplier) === index;
        });

        console.log(uniqueSuppliers);
        let filteredSupplierIds: any = uniqueSuppliers;
        const filteredItems = selectedItems.value.filter((item) => {
          return (
            item.hasOwnProperty("SupplierId") &&
            filteredSupplierIds.includes(item.SupplierId)
          );
        });

        console.log("filteredItems", filteredItems);
        const groupedItems = filteredItems.reduce(
          (accumulator, currentValue) => {
            const SupplierId = currentValue.SupplierId;
            if (!accumulator[SupplierId]) {
              accumulator[SupplierId] = [];
            }
            accumulator[SupplierId].push(currentValue);
            return accumulator;
          },
          {}
        );
        console.log(groupedItems);
        for (const key in groupedItems) {
          const currentArray = groupedItems[key];
          ObjVal.value.Id = 0;
          ObjVal.value.DocType = "5";

          ObjVal.value.StoreId = Number(QueryStringValue.value.StoreId);
          ObjVal.value.FromStore = Number(QueryStringValue.value.StoreId);
          ObjVal.value.ToStore = 0;
          // ObjVal.value.Amount = 0.00;
          ObjVal.value.SupplierId = currentArray[0]["SupplierId"];
          ObjVal.value.PaymentTermsId = 0;
          ObjVal.value.DeliveryTermsId = 0;
          ObjVal.value.IsDraft = 1;
          ObjVal.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          ObjVal.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          ObjVal.value.BranchId = Number(QueryStringValue.value.BranchId);
          ObjVal.value.HospitalId = usersData.OrganizationId;
          ObjVal.value.ModifiedBy = usersData.UserId;
          ObjVal.value.CreatedBy = usersData.UserId;
          ObjVal.value.EntityId = 3131;
          ObjVal.value.EntityOperationId = 3131001;
          ObjVal.value.DeptRoleId = rolesData.DeptRoleMapId;
          ObjVal.value.IsServiceLevel = 5;

          ObjVal.value.StoreBrMapId = Number(
            QueryStringValue.value.storebranchmapid
          );
          ObjVal.value.FromStoreBrMapId = Number(
            QueryStringValue.value.storebranchmapid
          );

          ObjVal.value.FromStoreBranchId = Number(
            QueryStringValue.value.BranchId
          );

          result = await WithoutStockService.createStockWOTM(ObjVal.value);
          id = result["result"];

          if (id != 0) {
            useConsigneePOStore.ConsigneePoIdList.push(id);
          }

          message = result["ErrorInfo"].ErrorCode;

          let POarr: any = [];
          if (message == null) {
            debugger;
            for (let i = 0; i < currentArray.length; i++) {
              let obj = {};

              (obj["Id"] = 0),
                (obj["ItemId"] = currentArray[i]["ItemId"]),
                (obj["Qty"] = currentArray[i]["ItemQuantity"]),
                (obj["RefId"] = id),
                // (obj["PackSizeId"] = currentArray[i]["PackSizeId"]),
                (obj["HSNId"] = currentArray[i]["HSNId"]),
                (obj["Rate"] = currentArray[i]["Rate"]),
                (obj["UnitRate"] = currentArray[i]["UnitRate"]),
                (obj["CreatedAt"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                (obj["ModifiedAt"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                (obj["CreatedBy"] = usersData.UserId),
                (obj["ModifiedBy"] = 0),
                (obj["Brand"] =
                  currentArray[i]["Brand"] == null ||
                    currentArray[i]["Brand"] == undefined
                    ? 0
                    : currentArray[i]["Brand"]),
                (obj["ModelNumber"] =
                  currentArray[i]["ModelNumber"] == null ||
                    currentArray[i]["ModelNumber"] == undefined
                    ? 0
                    : currentArray[i]["ModelNumber"]),
                (obj["Size"] =
                  currentArray[i]["Size"] == null ||
                    currentArray[i]["Size"] == undefined
                    ? 0
                    : currentArray[i]["Size"]),
                (obj["Status"] = 0),
                (obj["PurchaseTax"] =
                  currentArray[i]["PurchasePercentage"] || 0.0),
                (obj["PurchaseTaxAmount"] =
                  currentArray[i]["Purchasetaxamount"] || 0.0),
                (obj["SGSTTax"] = currentArray[i]["SGSTTax"] || 0.0),
                (obj["SGSTTaxAmount"] =
                  currentArray[i]["SGSTTaxAmount"] || 0.0),
                (obj["CGSTTax"] = currentArray[i]["CGSTTax"] || 0.0),
                (obj["CGSTTaxAmount"] =
                  currentArray[i]["CGSTTaxAmount"] || 0.0),
                (obj["IGSTTax"] = currentArray[i]["IGSTTax"] || 0.0),
                (obj["IGSTTaxAmount"] =
                  currentArray[i]["IGSTTaxAmount"] || 0.0),
                (obj["Amount"] = currentArray[i]["Amount"] || 0.0),
                (obj["StockInId"] = currentArray[i]["StockInId"] || 0),
                (obj["StockInDetailId"] =
                  currentArray[i]["StockInDetailId"] || 0),
                (obj["DCType"] = currentArray[i]["DCType"] || 0),
                (obj["StockOutId"] = currentArray[i]["StockOutId"] || 0),
                (obj["StockOutDetailId"] =
                  currentArray[i]["StockOutDetailId"] || 0),
                (obj["DCType"] = currentArray[i]["DCType"] || 0),
                (POarr[i] = obj);
            }

            let result = await WithoutStockService.createStockWODetails(POarr);

            message = result["ErrorInfo"].ErrorCode;
          } else {
            alert("Somthing went wrong");
            return;
          }
          console.log();
        }

        if (message == null) {
          if (CommonObj.value.SaveAsDraft == 1) {
            alert(
              "your data has been saved for future editing. You can continue to work on your submission later."
            );
            setupHistoryManagement(router, 2);
          } else {
            localStorage.setItem(
              "ConsigneePoIdList",
              JSON.stringify(useConsigneePOStore.ConsigneePoIdList)
            );

            router.push({
              path: "/ConsigneeToPO",
              query: {
                param: "ConsigneeToPO",
              },
            });
          }
        } else {
          alert("Somthing went wrong");
          return;
        }
        // }
      } else {
        toast.add({
          severity: "info",
          summary: "Add the quantity for the Items",
          detail: "",
          life: 3000,
        });
        return;
      }
    }

    return {
      TodayDate,
      selectedItems,
      globalFilterFields,
      filters,
      loading,
      AddItemmodel,
      POheaders,
      Items,
      ItemSearchFunction,
      CommonObj,
      SelectItem,
      IsSubmit,
      IsCreatePO,
      DateFilter,
      ClearDateFilter,
      ObjFilters,
      SupplierOnChange,
      BrandOnChange,
      ModelNumberOnChange,
      SizeOnChange
    };
  },
  created() { },
});
</script>
<style lang="scss">
.requestlabel {
  display: block !important;
}

.spantxt {
  font-size: 11px;
  color: grey;
}

.prtopo .p-dropdown.p-dropdown-clearable .p-dropdown-label {
  padding-right: 0.5rem !important;
}

.proceedbtn .p-button {
  background-color: #3096ff;
  padding: 5px 15px;
  border: 1px solid #3096ff;

  .p-button-label {
    font-weight: 500;
  }
}

.proceedbtn .p-button:hover {
  background-color: #3096ff !important;
  padding: 5px 15px;
  border: 1px solid #3096ff;
}

.prtable .p-tabview .p-tabview-nav {
  width: max-content !important;
}
</style>
<style lang="scss" scoped>
.actioncardbg {
  border: 1px solid #e1e1e1;
  align-items: center;
  padding: 10px;
  background-color: #f9fbfc;
  border-radius: 5px;
  margin: 15px 0;

  .selectedcount {
    font-weight: 500;
  }
}

.supplierlistbg {
  background-color: #000000;
  border: 1px solid #303132;
  display: flex;
  align-items: center;

  .supplieractionbtnsbg {
    border-right: 1px solid #e1e1e1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 10px 5px;
    width: 100px;

    .pi {
      font-size: 25px;
    }
  }

  .supplierdetails {
    //   width: 850px;
    width: 950px;
    margin-right: 21px;
    overflow: auto;
    display: flex;
    align-items: center;

    .suppliercardsbg {
      border-right: 1px solid #e1e1e1;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      color: #ffffff;
      min-width: 250px;
    }
  }

  .proceedbtn {
    float: right;
  }
}

.savedraftbtn {
  border: 1px solid #999999;
  padding: 5px 15px;
  width: max-content;
  border-radius: 5px;
  background-color: #ffffff;

  p {
    color: #999999;
  }
}

.scroll-container {
  overflow-x: auto;
  white-space: nowrap;
  border: 1px solid #ccc;
}

.w-90 {
  width: 90%;
}

.card-search .pi-search {
  position: absolute !important;
  top: 0.75rem;
  left: 0.55rem;
  color: #e1e1e1;
}
</style>
